import { Navigate, useLocation, useParams } from "react-router-dom";

const ExploreDateRedirect = () => {
    const { date } = useParams();
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    if (date) searchParams.set("date", date);

    return <Navigate to={{ pathname: "/explore", search: searchParams.toString() }} replace />;
};

export { ExploreDateRedirect };
